import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const Eyebrow = ({ children, className }) => (
  <span className={cn("eyebrow", className)}>{children}</span>
);

export const IconChip = ({ icon: Icon, className, active = false }) => (
  <span
    className={cn(
      "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border",
      active
        ? "border-primary/30 bg-primary-soft/50 text-primary"
        : "border-border bg-card-muted text-primary",
      className,
    )}
  >
    <Icon className="h-[18px] w-[18px]" strokeWidth={1.6} />
  </span>
);

export const SectionHeader = ({ eyebrow, title, caption, className }) => (
  <div
    className={cn(
      "mb-6 flex flex-wrap items-end justify-between gap-x-8 gap-y-1.5",
      className,
    )}
  >
    <div>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <h2 className="mt-2 font-display text-2xl font-medium leading-tight tracking-tightish text-foreground sm:text-[28px]">
        {title}
      </h2>
    </div>
    {caption ? (
      <div className="pb-1 text-sm text-muted-foreground">{caption}</div>
    ) : null}
  </div>
);

export const FadeIn = ({ children, delay = 0, className }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ToolCard = ({ icon, title, desc, tag, onClick, compact = false, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={cn(
      "group flex h-full flex-col rounded-xl border border-border bg-card p-4 text-left shadow-soft transition-colors duration-200 hover:border-border-strong hover:bg-card-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
      compact ? "min-h-[100px]" : "min-h-[136px]",
    )}
  >
    <IconChip icon={icon} />
    <div className={cn("mt-auto", compact ? "pt-4" : "pt-5")}>
      <h3 className="text-[15px] font-medium leading-snug text-foreground">{title}</h3>
      {desc ? (
        <p className="mt-1 text-[13px] leading-snug text-muted-foreground">{desc}</p>
      ) : null}
      {tag ? (
        <span className="mt-2.5 inline-flex rounded-md bg-secondary px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
          {tag}
        </span>
      ) : null}
    </div>
  </button>
);
